import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

export default function KeyboardArrowDownIcon(
  props: SvgIconProps
): JSX.Element {
  return (
    <SvgIcon viewBox={'0 -960 960 960'} fontSize={'inherit'} {...props}>
      <path d="M480-344 240-584l56-56 184 184 184-184 56 56-240 240Z" />
    </SvgIcon>
  );
}
